export const enumInfoQuestion = {
    INFOCONTENU : 1,
    PREREQUIS : 2,
    DATEDEBUT : 3,
    ADISTANCE : 4,
    LANGUE : 5,
    COUT : 6,
    AUTRE : 7
}